import {NgModule} from '@angular/core';
import {EditDataComponent} from './edit-data.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        EditDataComponent
    ],
    declarations: [
        EditDataComponent
    ]
})
export class EditDataModule {

}